module.exports = __webpack_public_path__ + "media/images/favicon-22eb5a5d3ddeb95c8a77bdf8a43794a0.ico";